import { useCallback, useEffect, useState } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { addIconUser } from '../reducer/reducer';
import { useDropzone } from 'react-dropzone';
import { removeNulls } from 'utils';
import { useDesignPackage } from 'shared/hooks/helpers';
export const useIconLoadingUser = () => {
    const addIcon = useAction(addIconUser);
    const [iconSettings, setIconSettings] = useState([]);
    const [maintainColor, setMaintainColor] = useState(false);
    const allow_design_package = useDesignPackage();
    const is_demo = useAppSelector((state) => state.account.is_demo);
    const set_message_action = useAppSelector((state) => state.user_icons.message);
    const onDrop = useCallback((accepted_files) => {
        if (accepted_files == null) {
            return;
        }
        if (accepted_files.some((el) => el.type !== 'image/svg+xml')) {
            setIconSettings((prevIconSettings) => [
                ...prevIconSettings,
                {
                    files: null,
                    src: null,
                    message: 'Файл должен быть в формате SVG.',
                },
            ]);
        }
        else {
            if (accepted_files.some((el) => el.size > 100001)) {
                setIconSettings((prevIconSettings) => [
                    ...prevIconSettings,
                    {
                        files: null,
                        src: null,
                        message: 'Размер файла превышает 100кБ.',
                    },
                ]);
            }
            else {
                const newIcon = accepted_files.map((icon) => ({
                    message: 'Выбран файл:',
                    src: URL.createObjectURL(icon),
                    files: icon,
                }));
                setIconSettings((prevIconSettings) => [...prevIconSettings, newIcon].flat(1));
            }
        }
    }, []);
    useEffect(() => {
        iconSettings.forEach(({ src }) => {
            if (src) {
                return URL.revokeObjectURL(src);
            }
        });
    }, []);
    const onChangeMaintainColor = useCallback(() => {
        setMaintainColor(!maintainColor);
    }, [maintainColor]);
    const onDeletePreview = useCallback(() => {
        setIconSettings([]);
        setMaintainColor(false);
    }, []);
    const onSendToServer = useCallback(() => {
        if (iconSettings.length === 0) {
            alert('Не выбран файл для загрузки.');
        }
        else {
            const data = removeNulls(iconSettings.map((el) => {
                if (el.files !== null) {
                    return {
                        file: el.files,
                        maintainColor: maintainColor,
                    };
                }
                return null;
            }));
            if (data.length > 0)
                addIcon(data);
            setIconSettings((prevIconSettings) => [
                ...prevIconSettings,
                {
                    files: null,
                    src: null,
                    message: `${set_message_action?.title ?? ''}. ${set_message_action?.message ?? ''}`,
                },
            ]);
            setMaintainColor(false);
            setTimeout(() => setIconSettings([]), 1500);
        }
    }, [onDrop, iconSettings.length, maintainColor]);
    const validDrop = !allow_design_package || is_demo;
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        disabled: validDrop,
    });
    return {
        iconSettings,
        maintainColor,
        onChangeMaintainColor,
        onDeletePreview,
        onSendToServer,
        getInputProps,
        getRootProps,
        isDragActive,
    };
};
